<template>
  <v-app class>
    <v-toolbar app style="background-color: #fff;">
      <v-toolbar-title class="headline text-uppercase">
        <v-img src="https://pwa.asfarma.com/res/logo.svg" width="198" height="60"></v-img>
      </v-toolbar-title>

      <v-spacer></v-spacer>
      <v-toolbar-items class="hidden-sm-and-down">
        <v-btn flat disabled>
          <v-icon class>phone</v-icon>
          <span>+90 212-442 50 28</span>
        </v-btn>
        <v-btn flat disabled>
          <v-icon class>email</v-icon>&nbsp;info@asfarma.com
        </v-btn>
      </v-toolbar-items>
    </v-toolbar>

    <v-content wrap>
      <vue-flux
        class="slider"
        :options="fluxOptions"
        :images="fluxImages"
        :transitions="fluxTransitions"
        ref="slider"
      >
        <flux-pagination slot="pagination"></flux-pagination>
      </vue-flux>
      <section class="container">
        <Products/>
      </section>

      <about/>

      <subscribe/>
    </v-content>
    <core-footer/>
  </v-app>
</template>

<script>
import { VueFlux, FluxPagination, Transitions } from "vue-flux";
import Products from "./components/Products";

export default {
  name: "App",
  components: {
    Products,
    VueFlux,
    FluxPagination,
    CoreFooter: () => import("@/components/Footer"),
    About: () => import("@/components/About"),
    Subscribe: () => import("@/components/Subscribe")
  },
  data() {
    return {
      fluxOptions: {
        autoplay: true,
        transitionFade: {
          totalDuration: 200,
          easing: "ease"
        },
        transitionBlocks2d2: {
          numRows: 5,
          numCols: 5,
          tileDelay: 50
        }
      },
      fluxImages: [
        "https://pwa.asfarma.com/bn/b1.jpg",
        "https://pwa.asfarma.com/bn/b2.jpg",
        "https://pwa.asfarma.com/bn/b3.jpg",
        "https://pwa.asfarma.com/bn/b4.png",
        "https://pwa.asfarma.com/bn/b5.png",
        "https://pwa.asfarma.com/bn/b6.jpg"
      ],
      fluxTransitions: {
        transitionWaterfall: Transitions.transitionWaterfall,
        transitionZip: Transitions.transitionZip,
        transitionWave: Transitions.transitionWave,
        transitionBlocks2: Transitions.transitionBlocks2,
        transitionConcentric: Transitions.transitionConcentric,
        transitionRound2: Transitions.transitionRound2
      }
    };
  }
};
</script>

<style scoped>
@media all and (min-width: 800px) {
  .slider {
    height: 400px;
    position: relative;
    width: 1900px;
  }
}
</style>